import React, { useContext } from "react";
import { Container, Dropdown, Nav, Navbar } from "react-bootstrap";
import { Store } from "../../Store";
import { FaUserCircle } from "react-icons/fa";
import { HiOutlineMenuAlt2, HiOutlineX } from "react-icons/hi";

export default function Header({ sidebarHandler, isExpanded }) {
  const { state } = useContext(Store);
  const { userInfo } = state;

  if (!userInfo) {
    return null;
  }

  return (
    <Navbar className="header">
      <Container fluid className="ps-0">
        <button
          type="button"
          className="header-menu-button"
          onClick={() => sidebarHandler()}
          aria-label="Toggle sidebar navigation"
          aria-expanded={isExpanded}
        >
          {isExpanded ? <HiOutlineX size={20} /> : <HiOutlineMenuAlt2 size={20} />}
        </button>

        <Nav className="ms-auto">
          <Dropdown align="end">
            <Dropdown.Toggle id="user_profile" className="right-profile-logo">
              <FaUserCircle size={"25px"} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Header>
                Signed in as
                <br />
                <b>{userInfo?.name || userInfo?.email}</b>
              </Dropdown.Header>
            </Dropdown.Menu>
          </Dropdown>
        </Nav>
      </Container>
    </Navbar>
  );
}
